module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-1fa5ddc4.png";